import { track } from '@amplitude/analytics-browser';
import ReqMoreInfoModal from '@features/employerOnboarding/components/PickPlanStep/ReqMoreInfoModal';
import { Button, Stack, Typography } from '@mui/material';
import { darkBlue2, white } from '@styles/colors';
import { bold } from '@styles/fontWeights';
import { amplitudeEventsName } from '@utils/amplitudeEvents';
import { useState } from 'react';

function HaveMoreLocations({
  isModalContent,
  handleClose,
}: {
  isModalContent?: boolean;
  handleClose?: () => void;
}) {
  const [showReqInfoModal, setShowReqInfoModal] = useState<boolean>(false);

  const hanldeReqModal = () => {
    setShowReqInfoModal(!showReqInfoModal);
  };
  return (
    <>
      <Stack
        sx={{ textAlign: 'center', marginTop: isModalContent ? '0' : '15px' }}
        alignItems="center"
        spacing={2}
        bgcolor={white}
        p={isModalContent ? 0 : 3}
        borderRadius={8}
      >
        <Typography
          sx={{ fontWeight: bold }}
          variant={isModalContent ? 'h3' : 'h2'}
          gutterBottom
        >
          Multiple Locations?
        </Typography>
        <Typography
          sx={{ margin: '0 auto' }}
          maxWidth={isModalContent ? '350px' : '650px'}
          variant="body1"
          gutterBottom
        >
          Streamline hiring for your whole company whether you’re 2 or 2,000
          locations & growing. Multi-location discounts available. Contact us
          for discounted custom-pricing.
        </Typography>
        <Button
          variant="outlined"
          sx={{
            width: 'fit-content',
            textTransform: 'none',
            color: darkBlue2,
            marginBottom: isModalContent ? '10px !important' : '0',
          }}
          onClick={() => {
            track(
              isModalContent
                ? amplitudeEventsName.REQUEST_MORE_INFORMATION_CLICKED_APPLICANTS
                : amplitudeEventsName.REQUEST_MORE_INFORMATION_CLICKED_MANAGE_USERS,
            );
            hanldeReqModal();
          }}
        >
          Request More Information
        </Button>
      </Stack>
      {showReqInfoModal && (
        <ReqMoreInfoModal
          open={showReqInfoModal}
          handleClose={hanldeReqModal}
          handleCloseParent={handleClose}
        />
      )}
    </>
  );
}

export default HaveMoreLocations;
